module.exports = __webpack_public_path__ + "img/momoka.117375db.jpg";